import React from "react";

interface AnimatedWavePlaceholderProps {
  className?: string;
}

export const AnimatedWavePlaceholder: React.FC<AnimatedWavePlaceholderProps> = ({ className }) => {
  return (
    <svg
      className={className}
      viewBox="0 -150 1000 500"
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Animated wave placeholder"
      style={{ display: "block" }}
    >
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#4dd2ff" />
          <stop offset="50%" stopColor="#ffe36a" />
          <stop offset="100%" stopColor="#ff00ff" />
        </linearGradient>
        <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#4dd2ff" />
          <stop offset="50%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#ff00ff" />
        </linearGradient>
      </defs>

      {/* Primary wave */}
      <path
        d="M0,100 Q50,50 100,100 T200,100 T300,100 T400,100 T500,100 T600,100 T700,100 T800,100 T900,100 T1000,100 T1100,100 T1200,100 T1300,100 T1400,100 T1500,100 T1600,100 T1700,100 T1800,100 T1900,100 T2000,100"
        fill="transparent"
        stroke="url(#grad1)"
        strokeWidth="4"
        strokeLinecap="round"
      >
        <animateTransform
          attributeName="transform"
          type="translate"
          from="0 0"
          to="-1000 0"
          dur="11s"
          repeatCount="indefinite"
        />
      </path>

      {/* Secondary, slightly offset wave */}
      <path
        d="M0,110 Q50,60 100,110 T200,110 T300,110 T400,110 T500,110 T600,110 T700,110 T800,110 T900,110 T1000,110 T1100,110 T1200,110 T1300,110 T1400,110 T1500,110 T1600,110 T1700,110 T1800,110 T1900,110 T2000,110"
        fill="transparent"
        stroke="url(#grad2)"
        strokeWidth="4"
        strokeLinecap="round"
        opacity="0.6"
      >
        <animateTransform
          attributeName="transform"
          type="translate"
          from="0 0"
          to="-1000 0"
          dur="9s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
};
